import { FC } from 'react';

import clsx from 'clsx';
import { ChevronDown, Folder, FolderOpen } from 'lucide-react';

import TableCell from '@mui/material/TableCell';

import css from './FolderNameColumn.module.css';

interface FolderNameColumnProps {
  name: string;
  isExpanded: boolean;
  onExpand: VoidFunction;
  depth: number;
}

export const FolderNameColumn: FC<FolderNameColumnProps> = ({ name, isExpanded, onExpand, depth }) => (
  <TableCell style={{ paddingLeft: depth * 30 }}>
    <button className={css.folderNameColumnButton} onClick={onExpand}>
      {isExpanded ? <FolderOpen /> : <Folder />}

      <p className={css.folderName}>{name}</p>

      <ChevronDown className={clsx(isExpanded && css.rotate)} width={18} opacity={0.5} />
    </button>
  </TableCell>
);
